// 首页翻译 - 智能体相关、首页展示等

export const zh = {
  // Home
  slogan: 'All Agents, One Pouch',
  placeholder: '进入多元宇宙...',
  online: '在线',
  offline: '离线',
  recommended: '推荐场景',

  // Create Agent Page - additional keys
  chars: '字符',
  complete: '完成',
  input: '输入中',

  // 首页场景示例（点击即真实执行）
  tip: '提示',
  
  // Create Agent Page - Preview

  // Expert Names
  commander: '指挥官',
  codingExpert: '编程专家',
  researchExpert: '研究专家',
  writingExpert: '写作专家',
  planningExpert: '规划专家',
}

export const en = {
  // Home
  slogan: 'All Agents, One Pouch',
  placeholder: 'Enter Multiverse...',
  online: 'ON',
  offline: 'OFF',
  recommended: 'Recommended',

  // Create Agent Page - additional keys
  chars: 'chars',
  complete: 'Complete',
  input: 'Input',

  // Home scene examples (click to run live)
  tip: 'Tip',
  
  // Create Agent Page - Preview

  // Expert Names
  commander: 'Commander',
  codingExpert: 'Coding Expert',
  researchExpert: 'Research Expert',
  writingExpert: 'Writing Expert',
  planningExpert: 'Planning Expert',
}

export const ja = {
  // Home
  slogan: 'All Agents, One Pouch',
  placeholder: 'マルチバースに入る...',
  online: 'オン',
  offline: 'オフ',
  recommended: 'おすすめシーン',

  // Create Agent Page - additional keys
  chars: '文字',
  complete: '完了',
  input: '入力中',

  // ホームシーン例（クリックで実際に実行）
  tip: 'ヒント',
  
  // Create Agent Page - Preview

  // Expert Names
  commander: 'コマンダー',
  codingExpert: 'プログラミングエキスパート',
  researchExpert: '研究エキスパート',
  writingExpert: 'ライティングエキスパート',
  planningExpert: 'プランニングエキスパート',
}
